import * as CookieConsent from "vanilla-cookieconsent";
import { loadGTM, removeGTM } from "@/lib/gtm";

let initialized = false;

export function initCookieConsent(gtmId: string | null): void {
	if (initialized) return;
	initialized = true;

	CookieConsent.run({
		// Do not block page interaction. A blocking overlay leaves the page
		// unusable when a browser extension (e.g. "I don't care about cookies")
		// only hides the visible banner but not the interaction lock.
		disablePageInteraction: false,

		categories: {
			necessary: {
				enabled: true,
				readOnly: true,
			},
			analytics: {
				enabled: false,
				autoClear: {
					cookies: [{ name: /^_ga/ }, { name: /^_gid/ }, { name: /^_gat/ }],
				},
			},
		},

		language: {
			default: "de",
			translations: {
				de: {
					consentModal: {
						title: "Wir verwenden Cookies",
						description:
							"Wir nutzen Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Einige Cookies sind technisch notwendig, während andere uns helfen, die Website zu verbessern und Ihr Nutzungserlebnis zu analysieren.",
						acceptAllBtn: "Alle akzeptieren",
						acceptNecessaryBtn: "Nur notwendige",
						showPreferencesBtn: "Einstellungen verwalten",
					},
					preferencesModal: {
						title: "Cookie-Einstellungen",
						acceptAllBtn: "Alle akzeptieren",
						acceptNecessaryBtn: "Nur notwendige",
						savePreferencesBtn: "Einstellungen speichern",
						sections: [
							{
								title: "Cookie-Nutzung",
								description:
									"Wir verwenden Cookies, um die grundlegenden Funktionen der Website sicherzustellen und Ihr Online-Erlebnis zu verbessern. Sie können für jede Kategorie entscheiden, ob Sie diese zulassen oder ablehnen möchten.",
							},
							{
								title: "Technisch notwendige Cookies",
								description:
									"Diese Cookies sind für das ordnungsgemäße Funktionieren der Website erforderlich. Sie können nicht deaktiviert werden.",
								linkedCategory: "necessary",
							},
							{
								title: "Analyse & Statistik",
								description:
									"Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie Informationen anonym sammeln und melden.",
								linkedCategory: "analytics",
							},
						],
					},
				},
			},
		},

		onConsent: () => {
			if (CookieConsent.acceptedCategory("analytics") && gtmId) {
				loadGTM(gtmId);
			}
		},

		onChange: ({ changedCategories }) => {
			if (changedCategories.includes("analytics")) {
				if (CookieConsent.acceptedCategory("analytics") && gtmId) {
					loadGTM(gtmId);
				} else {
					removeGTM();
				}
			}
		},
	});
}
